export default __webpack_public_path__ + "static/media/CommentaryField.4f552888.svg";